/**
 * Format leave numbers (balance, days, etc.) to always show 2 decimal places
 * - If input is null/undefined/empty, returns "0.00"
 * - Always formats to 2 decimal places for consistency
 * - Handles both number and string inputs
 */
export const formatLeaveNumber = (num: unknown): string => {
  if (num === null || num === undefined || num === "") return "0.00";

  const n = typeof num === "string" ? parseFloat(num) : Number(num);

  if (Number.isNaN(n)) return "0.00";

  // Always format to 2 decimal places
  return n.toFixed(2);
};
